import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ArrayChecker } from '../../../components';
import { TableNav } from '../../../components/partner-table';
import TestimonialTable from '../../../components/testimonial/testimoni-table';
import apiService from '../../../features/api/service';
import { fetchEvent } from '../../../features/event/slice';
import { errorHandler } from '../../../utils';
import TestimonialForm from './testimonial-form';

const links = [
  {
    label: 'Internal',
    value: 'internal'
  },
  {
    label: 'External',
    value: 'external'
  }
]

const SectionTestimonial = () => {
  const dispatch = useDispatch()
  const [isEditing, setIsEditing] = useState(false)
  const [selected, setSelected] = useState({})
  const {
    testimonials,
    testimonials_external,
    id: eventId
  } = useSelector(state => state.event.data)
  const [activeTab, setActiveTab] = useState(links[0].value)

  const handleEdit = (e) => {
    console.log({e})
    setSelected(e)
    setIsEditing(true)
  }

  const handleDelete = (e) => {
    if(e.id){
      apiService.delete('testimoni_external', e.id)
        .then(res => {
          toast.success('Deleted.')
          dispatch(fetchEvent(eventId))
        })
        .catch(err => {
          const msg = errorHandler(err)
          toast.error(msg)
        })
    }
  }

  const handleDeleteInternal = (e) => {
    if(e.id){
      apiService.delete('testimoni_internal', e.id)
        .then(res => {
          toast.success('Deleted.')
          dispatch(fetchEvent(eventId))
        })
        .catch(err => {
          const msg = errorHandler(err)
          toast.error(msg)
        })
    }
  }

  return <>
    <p className="text-lg font-bold mb-5 lg:mb-8">Testimonial</p>
    {
      !isEditing &&
      <div>
        <TableNav links={links} activeTab={activeTab} setActiveTab={setActiveTab}/>

        <div className="overflow-y-auto" style={{maxHeight: '500px'}}>
          {
            activeTab === 'internal' &&
            <ArrayChecker data={testimonials}>
              <TestimonialTable
                data={testimonials}
                onDelete={handleDeleteInternal}
              />
            </ArrayChecker>
          }
          {
            activeTab === 'external' &&
            <ArrayChecker data={testimonials_external}>
              <TestimonialTable
                data={testimonials_external}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
            </ArrayChecker>
          }
        </div>
      </div>
    }
    {
      isEditing &&
      <TestimonialForm
        data={selected}
        withImage={true}
        onUpdated={() => setIsEditing(false)}
      />
    }
  </>
}

export default SectionTestimonial
